import { getMessages } from '../../../../../../../store/constants';

export const CARD_CHECKLIST_DONE = 'card_form_checklist_done';
export const CARD_CHECKLIST_SAVE_BUTTON = getMessages().getText('card_form_checklist_save');
export const CARD_CHECKLIST_ITEM_ADD_TOOLTIP = getMessages().getText('card_form_checklist_add_item');
export const CARD_CHECKLIST_SHOW_DONE = getMessages().getText('card_form_checklist_show_done_items');
export const CARD_CHECKLIST_HIDE_DONE = getMessages().getText('card_form_checklist_hide_done_items');
